
import React from 'react';
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
export const PlatformShowcase = () => {
  const {
    t
  } = useTranslation("landing");

  // Video data with sources and descriptions
  const videos = [{
    src: "https://app.videas.fr/embed/media/29bd1e11-0714-4822-9804-22f9f9dd3935/?title=false&logo=false&thumbnail_duration=false&controls=false&autoplay=true&loop=true",
    description: "Vores udbudsportal og -agent gør det nemt at finde udbud, der matcher jeres virksomhedsprofil"
  }, {
    src: "https://app.videas.fr/embed/media/a0081275-e07d-4a62-b756-d169edd4237c/?title=false&logo=false&thumbnail_duration=false&controls=false&autoplay=true&loop=true",
    description: "Udbudsoversigten giver jer de oplysninger, I har brug for på en nem og overskuelig måde"
  }, {
    src: "https://app.videas.fr/embed/media/ce80c23f-2766-4329-995e-923f68b153da/?title=false&logo=false&thumbnail_duration=false&controls=false&autoplay=true&loop=true",
    description: "Gennem jeres personlige dashboard, kan I nemt tilgå jeres gemte udbud og arbejde på jeres vindende tilbud."
  }];
  return <section className="relative py-24 bg-gray-50">
      <motion.div className="text-center mb-16" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }}>
        <h2 className="text-3xl md:text-4xl font-bold mb-8 bg-gradient-to-r from-primary to-purple-600 bg-clip-text text-transparent leading-relaxed pb-1">
          {t("platformShowcase.title")}
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto -mt-[25px]">
          {t("platformShowcase.subtitle")}
        </p>
      </motion.div>

      <div className="container mx-auto px-4">
        <motion.div className="max-w-4xl mx-auto" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }}>
          <Carousel className="w-full relative">
            <CarouselContent>
              {videos.map((video, index) => <CarouselItem key={index}>
                  <div className="mb-8">
                    <div className="rounded-xl overflow-hidden shadow-lg">
                      {/* Using 16/8.4 aspect ratio with a slightly increased scale to ensure no black borders */}
                      <div className="aspect-[16/8.4] relative overflow-hidden">
                        <iframe src={video.src} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full scale-[1.02]" referrerPolicy="unsafe-url" title={`Platform Showcase ${index + 1}`} />
                      </div>
                    </div>
                    <div className="mt-4 p-4 bg-white rounded-lg shadow-md">
                      <p className="text-gray-700 text-center">{video.description}</p>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <div className="flex justify-center mt-4">
              <CarouselPrevious className="relative -left-0 top-0 translate-y-0 mx-2" />
              <CarouselNext className="relative -right-0 top-0 translate-y-0 mx-2" />
            </div>
          </Carousel>
        </motion.div>
      </div>
    </section>;
};
